import React, { FC } from 'react';
import {
  CardInfo,
  CardInfoItem,
  CardInfoValueType,
  FlexItem,
  H3,
} from '@erecruit/ui-kit';
import { Intl } from '@erecruit/core';
import { Resources } from '@erecruit/types';

const { FormattedMessage } = Intl;

type GeneralSectionProps = {
  data: Resources.Shift;
};

const GeneralSection: FC<GeneralSectionProps> = props => {
  const {
    description,
    shiftType,
    facilityDepartments,
    cancellationReason,
    isCancelled,
  } = props.data;

  return (
    <FlexItem>
      <CardInfo
        title={
          <H3 align="center">
            <FormattedMessage id={messageIds.vms.shiftRecord.general.title} />
          </H3>
        }
      >
        <CardInfoItem
          label={
            <FormattedMessage
              id={messageIds.vms.shiftRecord.general.description}
            />
          }
          type={CardInfoValueType.Text}
          value={description ?? '-'}
        />
        <CardInfoItem
          label={
            <FormattedMessage
              id={messageIds.vms.shiftRecord.general.shiftType}
            />
          }
          type={CardInfoValueType.Text}
          value={shiftType?.name ?? '-'}
        />
        <CardInfoItem
          label={
            <FormattedMessage
              id={messageIds.vms.shiftRecord.general.department}
            />
          }
          type={CardInfoValueType.Text}
          value={
            facilityDepartments.length > 0
              ? facilityDepartments?.map(({ name }) => name)
              : '-'
          }
        />
        {isCancelled ? (
          <CardInfoItem
            label={
              <FormattedMessage
                id={messageIds.vms.shiftRecord.general.cancellationReason}
              />
            }
            type={CardInfoValueType.Text}
            value={cancellationReason?.name ?? '-'}
          />
        ) : null}
      </CardInfo>
    </FlexItem>
  );
};

export default GeneralSection;
